/**
 * Öffentliche Basis-URL der externen API. Das Portal läuft auf portal.meisterpfad.de und leitet
 * /api/* nur per Vercel-Rewrite weiter; externe Clients sprechen den API-Host direkt an.
 * Für Staging per VITE_PUBLIC_API_BASE_URL überschreibbar.
 */
const fromEnv = String((import.meta as { env?: Record<string, string | undefined> }).env?.VITE_PUBLIC_API_BASE_URL ?? '').trim();

export const PUBLIC_API_BASE_URL = (fromEnv || 'https://api.meisterpfad.de').replace(/\/+$/, '');

export const PUBLIC_API_V1_URL = `${PUBLIC_API_BASE_URL}/api/integrations/v1`;

export function publicApiInstanceBaseUrl(instanceId: string | null | undefined): string {
  return `${PUBLIC_API_V1_URL}/instances/${instanceId ?? '<INSTANZ-ID>'}`;
}

/** Spec wird same-origin geladen (Session-Cookie), nicht vom API-Host. */
export const OPENAPI_SPEC_PATH = '/api/integrations/v1/openapi.json';
